var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomRightOrnament(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.244,
    height: 311.703,
    viewBox: "0 0 135.244 311.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Agrupar_219",
    "data-name": "Agrupar 219",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Agrupar_58",
    "data-name": "Agrupar 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M217.555,368.869v79.417H204.874V368.869a121.725,121.725,0,0,1,36.038-86.494l52.716-52.6v17.923l-43.749,43.645A109.139,109.139,0,0,0,217.555,368.869Z",
    transform: "translate(-158.384 -155.485)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M217.555,393.2v107.31H204.874V393.2a121.739,121.739,0,0,1,36.038-86.5l99.205-98.993v17.933l-90.239,90.027A109.139,109.139,0,0,0,217.555,393.2Z",
    transform: "translate(-204.874 -207.708)",
    fill: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Agrupar_57",
    "data-name": "Agrupar 57",
    transform: "translate(0.001 287.989)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_694",
    "data-name": "Ret\\xE2ngulo 694",
    width: 12.679,
    height: 23.714,
    transform: "translate(46.49)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_695",
    "data-name": "Ret\\xE2ngulo 695",
    width: 12.679,
    height: 23.714,
    transform: "translate(0 0)",
    fill: "#4d4d4d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRightOrnament);
export default __webpack_public_path__ + "static/media/bottom-right-ornament.1a8970967d9233d532a0420c76d1305b.svg";
export { ForwardRef as ReactComponent };